import React from 'react';
import { styled } from '@mui/material';

import { useViewport } from 'contexts/viewport';
import { useUser2 } from 'contexts/user2';
import { ProgressBar, Stack, Text } from 'shell/components';
import { getProgress, getUserPreferredFullName } from 'utils/helper';

const LeaderBoard = ({ groups = [], distribution = {}, ...rest }) => {
    const { device } = useViewport();
    const { studentAccountUsers } = useUser2();

    const sortedGroups = [...groups]?.sort((a, b) => getProgress(distribution, b.id) - getProgress(distribution, a.id));
    const topThreeGroups = sortedGroups.slice(0, 3);

    const mobileList = () => {
        return (
            <TeamStack justifyContent={'space-around'} spacing={4}>
                {topThreeGroups.map((group) => {
                    const members = studentAccountUsers?.filter((student) => student.group_id === group.id);
                    return (
                        <Stack key={group.id} spacing={4}>
                            <DataStack>
                                <Text sx={{ minWidth: '150px' }} noWrap variant={'p2'}>
                                    {members?.length === 1 ? getUserPreferredFullName(members[0]) : group.name}
                                </Text>
                            </DataStack>
                            <Stack alignItems={'center'} direction={'row'} spacing={1}>
                                <ProgressBar
                                    aria-label={'task completion progress'}
                                    value={Number(getProgress(distribution, group.id))}
                                />
                                <PercentageText align={'right'} variant={'p2'}>
                                    {Math.round(getProgress(distribution, group.id))}%
                                </PercentageText>
                            </Stack>
                        </Stack>
                    );
                })}
                {topThreeGroups.length < 3 && (
                    <Stack sx={{ marginBottom: 3 }} alignItems={'center'}>
                        <Text color={'light'}>No more teams to show</Text>
                    </Stack>
                )}
            </TeamStack>
        );
    };

    const desktopTabletList = () => {
        return (
            <TeamStack justifyContent={'space-around'}>
                {topThreeGroups.map((group) => {
                    const members = studentAccountUsers?.filter((student) => student.group_id === group.id);
                    return (
                        <Stack key={group.id} direction={'row'} spacing={2}>
                            <DataStack alignItems={'center'} direction={'row'} spacing={1}>
                                <Text sx={{ minWidth: '150px' }} noWrap variant={'p2'}>
                                    {members?.length === 1 ? getUserPreferredFullName(members[0]) : group.name}
                                </Text>
                                <ProgressBar
                                    aria-label={'task completion progress'}
                                    value={Number(getProgress(distribution, group.id))}
                                />
                            </DataStack>
                            <PercentageText align={'right'} variant={'p2'}>
                                {Math.round(getProgress(distribution, group.id))}%
                            </PercentageText>
                        </Stack>
                    );
                })}
                {topThreeGroups.length < 3 && (
                    <Stack alignItems={'center'}>
                        <Text color={'light'}>No more teams to show</Text>
                    </Stack>
                )}
            </TeamStack>
        );
    };

    return (
        <RootStack {...rest} spacing={4}>
            <Text weight={'semibold'} variant={'p2'}>
                Leaderboard
            </Text>
            {device === 'mobile' ? mobileList() : desktopTabletList()}
        </RootStack>
    );
};

const RootStack = styled(Stack)(() => {
    return {
        width: '100%',
        height: '100%',
    };
});

const TeamStack = styled(Stack)(() => {
    return {
        height: '100%',
    };
});

const DataStack = styled(Stack)(() => {
    return {
        flex: 1,
        width: 0,
    };
});

const PercentageText = styled(Text)(() => {
    return {
        width: '2.125rem',
    };
});

export default LeaderBoard;
